module.exports = __webpack_public_path__ + "img/transactions.daily.035b2e63.png";